(function () {
  /**
   * @ngdoc module
   * @name app.core.invites
   * @description Module which defines invite related constants
   */
  angular.module('app.core.invites', []);
})();
